module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-4-blocks-7c589b7f7afc1f87777a186df3f3c599.svg";